import React from 'react';
import { Tooltip, Button, Pagination } from 'antd';
import { Visibility, PlayArrow } from '@material-ui/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { PrizeDraw } from 'core/worldCup/prizeDraws/types';
import { PAGE_SIZE_OPTIONS } from 'utilities/constants';

type PrizeDrawsTableType = {
  prizeDrawsData: PrizeDraw[] | null;
  total: number;
  current: number;
  pageSize: number;
  onChangePage: (page: number, size: number) => void;
  setCurrent: (e: number) => void;
  setPageSize: (e: number) => void;
  onViewDetail: (id: number) => void;
  onStartRoulette: (id: number) => void;
};

const PrizeDrawsTable: React.FC<PrizeDrawsTableType> = ({
  prizeDrawsData,
  total,
  current,
  pageSize,
  onChangePage,
  setCurrent,
  setPageSize,
  onViewDetail,
  onStartRoulette,
}) => {
  const intl = useIntl();

  const handleChangePage = (page: number, size: number) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage(page, size);
  };

  const handleShowSizeChange = (c: number, s: number) => {
    handleChangePage(1, s);
  };

  return (
    <div className="prizeDraws_table_layout" id="prizeDraws_table_layout">
      <div className="table_header">
        <div className="id">
          <FormattedMessage id="ID" />
        </div>
        <div className="prize_type">
          <FormattedMessage id="Name" />
        </div>
        <div className="include_prev">
          <FormattedMessage id="Include previous winners" />
        </div>
        <div className="winners">
          <FormattedMessage id="Winners" />
        </div>
        <div className="executed_by">
          <FormattedMessage id="Alternate winners" />
        </div>
        <div className="status">
          <FormattedMessage id="Status" />
        </div>
        <div className="actions">
          <FormattedMessage id="Actions" />
        </div>
      </div>
      <div>
        <div className="table_content" id="prizeDraws_table_content">
          {Array.isArray(prizeDrawsData) &&
            prizeDrawsData.map((item, index) => (
              <div
                className={`table_item type_state_${item.status?.toLowerCase()}`}
                key={index}
                id={`prizeDraw_item_${item.id}`}
              >
                <div className="id">
                  <p>{item.id}</p>
                </div>
                <div className="prize_type">
                  <p>{item.name}</p>
                </div>
                <div className="include_prev">
                  <p>{intl.formatMessage({ id: item.includePreviousWinners ? 'Yes' : 'No' })}</p>
                </div>
                <div className="winners">
                  <p>{item.mainWinners}</p>
                </div>
                <div className="executed_by">
                  <p>{item.backupWinners}</p>
                </div>
                <div className="status">
                  <span className={`status_badge ${item.status?.toLowerCase()}`}>
                    {intl.formatMessage({ id: `draw_status_${item.status?.toLowerCase()}` })}
                  </span>
                </div>
                <div className="actions">
                  {(item.status === 'READY' || item.status === 'SPINNING') && (
                    <Tooltip
                      placement="top"
                      title={intl.formatMessage({ id: 'Start roulette' })}
                      id="prizeDraw_play_tooltip"
                    >
                      <Button
                        className="play_btn"
                        onClick={() => onStartRoulette(item.id)}
                        id="prizeDraw_play_btn"
                      >
                        <PlayArrow />
                      </Button>
                    </Tooltip>
                  )}
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: 'View details' })}
                    id="prizeDraw_view_tooltip"
                  >
                    <Button
                      className="edit_btn"
                      onClick={() => onViewDetail(item.id)}
                      id="prizeDraw_view_btn"
                    >
                      <Visibility />
                    </Button>
                  </Tooltip>
                </div>
              </div>
            ))}
        </div>
        <div className="pagination_wrapper">
          <Pagination
            showSizeChanger
            defaultCurrent={1}
            defaultPageSize={10}
            current={current}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            total={total}
            onChange={handleChangePage}
            onShowSizeChange={handleShowSizeChange}
          />
          <div className="total">Resultados: {total}</div>
        </div>
      </div>
    </div>
  );
};

export default PrizeDrawsTable;
